import React, { Component } from "react";
import {
  getAnswers,
  updateQuestionAnswers,
} from "../../../../services/formService";
import { getProjectLists } from "../../../../services/projectService";
import QAFooter from "./QAFooter";
import {isNullOrEmpty} from "../../../common/commonFuncs";

class TypePicklist extends Component {
  Lists = [];

  state = {
    Project_ID: this.props.Project_ID,
    Question_ID: this.props.Question_ID,
    Question_Answers: [{ Answer_ID: 0, Answer_Text: "" }],
    loading: true,
    origStates: {List_ID: 0, Custom_Render: null},
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    const { data: Lists } = await getProjectLists(this.state.Project_ID);
    this.Lists = Lists;

    let { data: Question_Answers } = await getAnswers(this.state.Question_ID);
    if (Question_Answers.length === 0) {
      Question_Answers = [{ Answer_ID: 0, Answer_Text: "" }];
    }
    this.setState({
      Question_Answers,
      loading: false,
      origStates: {
        List_ID: parseInt(Question_Answers[0]["Answer_Text"]),
        Custom_Render: this.props.Custom_Render,
      }
    });

    // disable re-map responses if this is a newly created widget that has not been saved yet
    if (Question_Answers[0]["Answer_Text"] === "") this.props.setRemapResponses(false);
  }

  async handleSave() {
    const Question_ID = await this.props.onSave(this.state.Question_Answers);
    if (Question_ID !== 0) {
      this.setState({
        Question_ID,
        origStates: {
          List_ID: this.state.Question_Answers[0]["Answer_Text"],
          Custom_Render: this.props.Custom_Render
        }
      });
    }
  }

  handleRemove() {
    this.props.onRemove();
  }

  handleListChange = (value) => {
    const Question_Answers = [...this.state.Question_Answers];
    Question_Answers[0]["Answer_Text"] = parseInt(value);
    this.setState({ Question_Answers });
  };

  /**
   * Allow re-mapping responses if selected list and custom rendering have NOT been changed
   * from what is currently saved.
   * @returns {boolean} True if allowed, False otherwise
   */
  verifyRemapResponses = () => {
    const origStates = this.state.origStates;
    return (origStates.List_ID === parseInt(this.state.Question_Answers[0]["Answer_Text"])) &&
           ((isNullOrEmpty(origStates.Custom_Render) && isNullOrEmpty(this.props.Custom_Render)) ||
               (origStates.Custom_Render === this.props.Custom_Render))
  }

  render() {
    if (this.state.loading) return <div className="center">Loading...</div>;
    let { Question_Answers } = this.state;
 
    return (
      <React.Fragment>
        <div className="form-group">
          <label>Select List</label>
          <select
            className="custom-select"
            value={Question_Answers[0].Answer_Text}
            onChange={(e) => this.handleListChange(e.target.value)}
          >
            <option>Please Select</option>
            {this.Lists.map((list) => {
              return (
                <option key={list.List_ID} value={list.List_ID}>
                  {list.List_Name}
                </option>
              );
            })}
          </select>
        </div>
        <QAFooter Widget_ID={this.props.Widget_ID}
                  handleSave={this.handleSave}
                  handleRemove={this.handleRemove}
                  showRemapResponses={true}
                  remapResponses={this.props.remapResponses}
                  setRemapResponses={this.props.setRemapResponses}
                  verifyRemapResponses={this.verifyRemapResponses}/>
      </React.Fragment>
    );
  }
}

export default TypePicklist;
